import { config } from "src/config";

const urlBuilder = (endPoint: string = "") => {
  return `${config.BASE_URL}${endPoint}`;
};

export default urlBuilder;
